import {lazy, Suspense} from "react";
import "@aws-amplify/ui-react/styles.css";
import {ThemeProvider} from "@aws-amplify/ui-react";
import {doonationTheme} from "./theme";
import {DataStore} from "aws-amplify/datastore";
import {Hub} from "aws-amplify/utils";

const Dashboard = lazy(() => import('./dashboard/DashboardApp'));
const Enduser = lazy(() => import('./enduser/EnduserApp'));

function App() {
  let hostname = window.location.hostname.split('.')[0];
  const Page =  (hostname === "dashboard") ? Dashboard : Enduser;

  Hub.listen('auth', async (data) => {
    if (data.payload.event === 'signOut') {
      console.log("clear DataStore")
      await DataStore.clear();
    }
  });

  return(
    <Suspense fallback={<div>Loading...</div>}>
      <ThemeProvider theme={doonationTheme}>
        <Page />
      </ThemeProvider>
    </Suspense>
  );
}

export default App;
